<template>
  <div>
    <form @submit.prevent="handleSubmit" class="add-comment">
      <div class="add-comment__avatar u-hide-mobile">
        <user-avatar :user="currentUser"/>
      </div>
      <div class="add-comment__form">
        <text-area
          v-model="comment"
          @quickKey="handleSubmit"
          class="textarea"
          placeholder="Write a comment"
        ></text-area>
        <p v-if="showError" class="danger">Please enter a comment before submitting</p>
      </div>
    </form>
  </div>
</template>

<script>
import TextArea from "@/components/forms/TextArea";
import { mapState } from "vuex";
const UserAvatar = () => import("@/components/UserAvatar");

export default {
  name: "AddComment",

  created() {
    this.$store.dispatch("auth/listCurrentUser");
  },
  computed: {
    ...mapState("auth", ["currentUser"])
  },
  methods: {
    handleSubmit() {
      if (this.comment.length < 1) {
        this.showError = true;
        return;
      }
      this.$emit("submit", this.comment);
      this.comment = "";
      this.showError = false;
    }
  },
  data() {
    return {
      comment: "",
      showError: false
    };
  },
  components: {
    TextArea,
    UserAvatar
  }
};
</script>

<style lang="scss">
.add-comment {
  &__avatar {
    max-width: 50px;
    max-height: 50px;
    margin-right: 5%;
  }
}
</style>
<style scoped lang="scss">
.add-comment {
  display: flex;

  &__avatar {
    flex: 1;

    img {
      border-radius: 100%;
    }
  }

  &__form {
    flex: 11;
    .textarea {
      width: 100%;
      border-radius: 18px;
      background: #f3f6f6;
      border: 1px solid $colour-nhs-pale-grey;
      padding: 15px;
      resize: none;
      box-sizing: border-box;
      line-height: 1;
      max-width: 90vw;
    }
  }
}
</style>